import { render, staticRenderFns } from "./SmartVoice.vue?vue&type=template&id=ab03f6f6"
import script from "./SmartVoice.vue?vue&type=script&lang=js"
export * from "./SmartVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports